module.exports = __webpack_public_path__ + "img/kalbsschnitzel.d4fae94e.png";